import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss']
})
export class ServerErrorComponent implements OnInit {


  @Input('maintainance') maintainance;
  constructor(public router: Router, public activatedRoute: ActivatedRoute) { 
    
  }

  ngOnInit() {
    
    let x = this.activatedRoute.snapshot.paramMap.get('maintenance')
    console.log("xxxxxxxxxxxxxxx", x)
    if(x){
      this.maintainance = true
    }else{
      this.maintainance = false
    }
  }

}
